import "./App.scss";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Landing from "./components/Landing/Landing";
import Privacypolicy from "./components/Privacypolicy/Privacypolicy";
import Termscondition from "./components/Termscondition/Termscondition";
import RngList from "./components/RngList/RngList";
function App() {
  return (
    <>
      <Router>
        <Switch>
          <Route exact path="/" component={Landing} />
             <Route exact path="/privacy-and-policy" component={Privacypolicy} />
                <Route exact path="/terms-and-conditions" component={Termscondition} />
                <Route exact path="/list" component={RngList} />
        </Switch>
      </Router>
    </>
  );
}

export default App;
